// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3WH2c","vLegacy":"SelectSecondary_vLegacy__3QOfE","error":"SelectSecondary_error__sv-pj","disabled":"SelectSecondary_disabled__WdWL_"};